import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import designReducer from './slices/designSlice';
import uiReducer from './slices/uiSlice';
import checkoutReducer from './slices/checkoutSlice';

export const store = configureStore({
  reducer: {
    design: designReducer,
    ui: uiReducer,
    checkout: checkoutReducer,
  },
  // Add middleware for RTK Query if needed
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for fabric objects that can't be serialized
        ignoredActions: ['design/setCanvas', 'design/updateCanvas'],
        // Ignore these paths in the state
        ignoredPaths: ['design.canvas'],
      },
    }),
});

// Enable refetchOnFocus/refetchOnReconnect features for RTK Query
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
